import { z } from "zod";

import { SingleEmployeeSchema } from "../../../components/EmployeePicker/utils";

import { actionItemsTableConfig, workspacesTableConfig } from "./config";

export const WorkspacesFiltersSchema = z.object({
	createdBy: SingleEmployeeSchema.optional(),
	participant: SingleEmployeeSchema.optional(),
	upcomingMeetingStart: z.date().optional(),
	upcomingMeetingEnd: z.date().optional(),
	previousMeetingStart: z.date().optional(),
	previousMeetingEnd: z.date().optional(),
	status: z.enum(workspacesTableConfig.statusOptions).optional(),
});
export type WorkspacesFilters = z.infer<typeof WorkspacesFiltersSchema>;

const EmployeeValueSchema = z.object({
	id: z.string(),
	name: z.string(),
});

export const ActionItemsFiltersSchema = z.object({
	createdBy: EmployeeValueSchema.nullable().optional(),
	assignee: EmployeeValueSchema.nullable().optional(),
	isUnassigned: z.array(z.literal("unassigned")).optional(),
	status: z.enum(actionItemsTableConfig.statusOptions),
	dueDateRange: z
		.object({
			from: z.date().optional(),
			to: z.date().optional(),
		})
		.optional(),
	workspace: z.string().optional(),
});
export type ActionItemsFilters = z.infer<typeof ActionItemsFiltersSchema>;
